// extracted by mini-css-extract-plugin
export default {"HeroSection":"HeroSection_HeroSection__TCENY","HeroText":"HeroSection_HeroText__sTWGX","SideImage":"HeroSection_SideImage__vyHEf"};